import React from 'react'
import './Project.css'
import { assets } from '../../assets/assests';
import { FaLink, FaGithub } from 'react-icons/fa';



export const Project = () => {
  const projects = [
  {
    title: "Gemini AI Clone",
    image: assets.gemini_icon,
    description: "A modern Gemini AI UI clone built with React and Vite. Integrated OpenAI API for chat functionality using Context API for global state management. Focused on clean UI design, message handling logic, and reusable component structure.",
    tech: ["React", "Vite", "CSS", "OpenAI API"],
    github: "https://github.com/ragulragulm/Gemini-Ai-clone",
    demo: "https://gemini-chatbot-ai.netlify.app"
  },
  {
    title: "Amazon Clone",
    image: assets.amazon3_icon,
    description: "Built a multi-page shopping layout with cart and order logic.Added quantity change, remove item, and dynamic price update.Checkout button shows or hides based on cart status.Simulated order tracking and summary preview",
    tech: ["HTML", "CSS", "JavaScript"],
    github: "https://github.com/ragulragulm/ragul-amazon",
    demo: "https://ragul-amazon.netlify.app"
  },
  {
  title: "Globoscope Movies",
  image: assets.movies_icon, // Make sure you've added this icon in your assets
  description: "Built a movie search app using TMDB API and React. Integrated Appwrite for secure movie saving and user auth. Added debounce search, loading animation, and error handling. Focused on clean UI, async API calls, and dynamic movie rendering.",
  tech: ["React", "CSS", "TMDB API", "Appwrite"],
  github: "https://github.com/ragulragulm/movies-app", // Replace with your actual GitHub repo
  demo: "http://allmovies-app.netlify.app" // Replace with your actual live link
}
,
  
  {
    title: "YouTube Clone",
    image: assets.youtube2_icon,
    description: "Recreated the homepage with video cards and sidebar layout.Included hover effects, channel layout, and menu toggle.Focused on alignment, spacing, and structure accuracy.Layout adapts well on different screen sizes.",
    tech: ["HTML", "CSS"],
    github: "https://github.com/ragulragulm/ragul.youtube-website",
    demo: "https://ragulragulm.github.io/ragul.youtube-website/"
  },
  {
    title: "Social Media",
    image: assets.socialmedia_icon,
    description: "Created a live post feed using API data.Added delete post and new post form logic.Used async functions to update the feed without reload.Components display user info, text, and interactions.",
    tech: ["React", "CSS","API Integration"],
    github: "https://github.com/ragulragulm/social-media-with-api",
    demo: "http://ragul-socialmedia.netlify.app"
  },
  {
    title: "Rock Paper Scissors",
    image: assets.rpsgame_icon,
    description:"Made an interactive game with score tracking.Added logic to show win, lose, or tie each round.Reset button clears the board for new sessions.Layout responds smoothly to all screen sizes.",
    tech: ["HTML", "CSS", "JavaScript"],
    github: "https://github.com/ragulragulm/ragul-rock-paper-scissors-game",
    demo: "http://ragul-rpsgame.netlify.app"
  }
];
  return (
    <div className="projects-section" id='Projects'>
      <h2>Projects</h2>
      <div className="projects-grid">
        {projects.map((proj, index) => (
          <div key={index} 
          className="project-card"
             data-aos={index % 2 === 0 ? 'zoom-in-up' : 'fade-up'}
             data-aos-delay={index * 100}>
            <img src={proj.image} alt={proj.title} />
            <h3 className="project-title">{proj.title}</h3>
            <p className="project-desc">{proj.description}</p>
            <div className="tech-stack">
              {proj.tech.map((t, i) => (
                <span key={i}>{t}</span>
              ))}
            </div>
            <div className="project-links">
              {proj.github && <a href={proj.github} target="_blank" rel="noreferrer"><FaGithub /> GitHub</a>}
              {proj.demo && <a href={proj.demo} target="_blank" rel="noreferrer"><FaLink /> Live Demo</a>}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
